import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsClienteEnderecoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/cliente-endereco');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async getEnderecosCliente(queries = {}) {
    try {
      const data = await this.api.get('/cliente-endereco/findByCliente', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/cliente-endereco', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/cliente-endereco', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Cliente');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/cliente-endereco/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/cliente-endereco/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Cliente');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.api.post('/cliente-endereco/delete', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Cliente');
    }
  }

  // Lista endereços pela PK interna do cliente (clienteid) — a rota antiga
  // getClienteEnderecoByClienteId filtra por uma coluna que NÃO é o id do cliente.
  async getEnderecosPorCliente(clienteid) {
    try {
      const { data } = await this.api.get(`/cliente-endereco/porCliente/${clienteid}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar endereços do cliente');
    }
  }

  async getClienteEnderecoByClienteId(id) {
    try {
      const { data } = await this.api.get(`/cliente-endereco/getClienteEnderecoByClienteId/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }

  async getLocalEntregaCliente(clienteId, queries) {
    try {
      const { data } = await this.api.get(`/cliente-endereco/getLocalEntregaCliente/${clienteId}`, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }
}
